module.exports = __webpack_public_path__ + "assets/img/report-button-1.5a8c16d9.png";